module.exports = __webpack_public_path__ + "img/u.f934e87c.jpg";